export const primaryColors: string[] = [
  '#482BD3',
  '#B068E3',
  '#49A369',
  '#6CA1E8',
  '#DE8D32',
  '#D25546',
];

export const secondaryColors: string[] = [
  '#8E71E5',
  '#D1A0F6',
  '#9FD8B8',
  '#A7D6FB',
  '#EECB84',
  '#E2A2A0',
];
